module.exports = __webpack_public_path__ + "static/media/item_2_5ll.5104448a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_5ll.png
// module id = 122
// module chunks = 0